// PT Methods. The image column stays in view via CSS (position: sticky), this
// brings the images in one after the other while the cards are scrolled past.

const initMethods = (methods) => {
  const images = [...methods.querySelectorAll('.methods__image')];

  if (!images.length) {
    return;
  }

  // only now, so the images stay visible when the script never runs
  methods.classList.add('methods--animated');

  let ticking = false;

  const update = () => {
    ticking = false;

    const rect = methods.getBoundingClientRect();
    const scrollable = rect.height - window.innerHeight;
    // 0 while the section enters, 1 once its end is reached
    const progress =
      scrollable > 0
        ? Math.min(Math.max(-rect.top / scrollable, 0), 1)
        : Number(rect.top < window.innerHeight);

    images.forEach((image, index) => {
      // the first image is there right away, the last one at the very end
      image.classList.toggle('is-visible', progress >= index / images.length);
    });
  };

  const request = () => {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(update);
  };

  update();

  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
};

export default initMethods;
